var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgYoutubeColor = function SvgYoutubeColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.523 15.137L9.52 8.344l6.484 3.406zm14.239-7.969s-.239-1.668-.957-2.398c-.91-.965-1.934-.97-2.403-1.024-3.359-.246-8.398-.246-8.398-.246h-.008s-5.039 0-8.398.246c-.47.055-1.493.059-2.407 1.024C.473 5.5.238 7.168.238 7.168S0 9.125 0 11.078v1.836c0 1.953.238 3.91.238 3.91s.235 1.664.953 2.399c.914.965 2.114.933 2.649 1.035 1.922.183 8.16.242 8.16.242s5.043-.008 8.402-.254c.47-.055 1.493-.058 2.403-1.023.718-.735.957-2.399.957-2.399s.238-1.957.238-3.91v-1.836c0-1.953-.238-3.91-.238-3.91zm0 0",
    fillRule: "evenodd",
    fill: "#ce1312"
  })));
};
export default SvgYoutubeColor;